import { Button, Checkbox, Col, Collapse, Space } from 'components/common'

export interface CustomerAdvanceSearchProps {
  onChange: () => void
}

export const CustomerAdvanceSearch = (): JSX.Element => {
  function onChange(e) {
    console.log(`checked = ${e.target.checked}`)
  }

  return (
    <>
      <div>
        <div>
          <Collapse expandIconPosition="right" ghost>
            <Collapse.Panel header="タグ付け" key="1">
              <p>"This is panel header 1"</p>
            </Collapse.Panel>
          </Collapse>
        </div>
        <div>
          <Collapse expandIconPosition="right" ghost>
            <Collapse.Panel header="ステータス" key="1">
              <Space direction={'vertical'}>
                <Col>
                  <Checkbox onChange={onChange}>アクティブ</Checkbox>
                </Col>
                <Col>
                  <Checkbox onChange={onChange}>下書き</Checkbox>
                </Col>
                <Col>
                  <Checkbox onChange={onChange}>アーカイブ済み</Checkbox>
                </Col>
                <Button>クリア</Button>
              </Space>
            </Collapse.Panel>
          </Collapse>
        </div>
        <div>
          <Collapse expandIconPosition="right" ghost>
            <Collapse.Panel header="公開状況" key="1">
              <p>"This is panel header 1"</p>
            </Collapse.Panel>
          </Collapse>
        </div>
        <div>
          <Collapse expandIconPosition="right" ghost>
            <Collapse.Panel header="注文数" key="1">
              <p>"This is panel header 1"</p>
            </Collapse.Panel>
          </Collapse>
        </div>
        <div>
          <Collapse expandIconPosition="right" ghost>
            <Collapse.Panel header="注文の日付" key="1">
              <p>"This is panel header 1"</p>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>
    </>
  )
}
